import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";

import ReceiptIcon from "@mui/icons-material/Receipt";
import { useSelector } from "react-redux";
import ItemCuotaCard from "~business/Cards/ItemCuotaCard";
import type { Cuota } from "~business/Cards/types";
import { CuotaPolizaResponse } from "~api/types";

const title = "Cuotas";

interface CuotasCardProps {
  isLoading: boolean;
}

const useReduxSelector = () =>
  useSelector<any, { cuotas: CuotaPolizaResponse[] | undefined }>((state) => {
    const currentPoliza = state.detallePolizaReducer.currentPoliza
      ? state.detallePolizaReducer.currentPoliza
      : {};
    return {
      cuotas: currentPoliza ? currentPoliza.cuotas : [],
    };
  });

const CuotasCard: React.FC<CuotasCardProps> = ({ isLoading }) => {
  const { cuotas } = useReduxSelector();

  return (
    <DetalleCard isLoading={isLoading} title={title} IconHeader={ReceiptIcon}>
      {cuotas &&
        Object.keys(cuotas).map((key) => (
          <ItemCuotaCard
            key={key}
            index={cuotas[Number(key)].numeroCuota}
            // La card sólo lee `value` en modo readOnly: las cuotas de la
            // póliza no traen valid ni focus, y el importe es un número.
            cuota={
              {
                index: cuotas[Number(key)].numeroCuota,
                fechaVencimiento: {
                  value: cuotas[Number(key)].fechaVencimiento,
                },
                importe: { value: cuotas[Number(key)].premio },
                vigenciaDesde: { value: cuotas[Number(key)].fechaDesde },
                vigenciaHasta: { value: cuotas[Number(key)].fechaHasta },
              } as unknown as Cuota
            }
            readOnly
          />
        ))}
    </DetalleCard>
  );
};

export default CuotasCard;
